import { ConfigurationId } from '@types';
import { FundListingDisplayComponent } from './fund-listing-display-component.interface';
import { PpssComponent } from './ppss/ppss.component';
import { Type } from '@angular/core';

export class FundListingComponentConfig {
  static readonly PPSS_MF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.MF
  );
  static readonly PPSS_MMF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.MMF
  );
  static readonly PPSS_ETF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.ETF
  );
  static readonly PPSS_CEF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.CEF
  );
  static readonly PPSS_TIF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.TIF
  );
  static readonly PPSS_VIP = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.VIP
  );
  static readonly PPSS_529 = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId._529
  );
  static readonly PPSS_SMA = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.SMA
  );
  static readonly PPSS_IF = new FundListingComponentConfig(
    'PPSS',
    PpssComponent,
    ConfigurationId.IF
  );
  static allConfigs: FundListingComponentConfig[] = [
    FundListingComponentConfig.PPSS_MF,
    FundListingComponentConfig.PPSS_MMF,
    FundListingComponentConfig.PPSS_ETF,
    FundListingComponentConfig.PPSS_CEF,
    FundListingComponentConfig.PPSS_TIF,
    FundListingComponentConfig.PPSS_VIP,
    FundListingComponentConfig.PPSS_529,
    FundListingComponentConfig.PPSS_SMA,
    FundListingComponentConfig.PPSS_IF,
  ];

  // returns matching config or undefined
  static getConfig(
    key: string,
    configurationName: ConfigurationId
  ): FundListingComponentConfig {
    return this.allConfigs.find((config: FundListingComponentConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    public readonly key: string,
    public readonly component: Type<FundListingDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
